// Placeholder content used to preview a template before the host has typed
// anything. Wording comes from the translation files under `samples.<type>`.
export const sampleEvent = (t, type) => {
  const key = type || "other";
  return {
    type: key,
    title: t(`samples.${key}.title`),
    hosts: t(`samples.${key}.hosts`),
    venue: t(`samples.${key}.venue`),
    address: "",
    date: "2027-06-12",
    time: "16:00",
    message: "",
    dressCode: "",
    rsvpDeadline: "",
  };
};

// Fills the blanks of a half-written event with sample text so the live
// preview never looks empty.
export const withSampleFallback = (t, event) => {
  const sample = sampleEvent(t, event.type);
  return {
    ...event,
    title: event.title || sample.title,
    hosts: event.hosts || (event.title ? "" : sample.hosts),
    venue: event.venue || sample.venue,
    date: event.date || sample.date,
    time: event.time || sample.time,
  };
};
